import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ControlHintComponent } from '../control-hint/control-hint.component';

/**
 * ControlContainer IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _uniqueIdCounter = 0;
@Component({
  selector: 'kb-control-container',
  templateUrl: './control-container.component.html',
  styleUrls: ['./control-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ ControlHintComponent ],
})
export class ControlContainerComponent {

  @Input({ required: true }) public controlId!: string;
  @Input() public showError?: boolean;

  @ViewChild('hintElement') public hintElement?: ControlHintComponent;

  private uniqueId = `${_uniqueIdCounter++}`;
  public labelId = `kb-control-container-label-${this.uniqueId}`;

}
